import { Pipe, PipeTransform } from '@angular/core';

/**
 *  A pipe to highlight display text that matches a given string
 */
@Pipe({
    name: 'boldMatchingText',
    standalone: false
})
export class BoldMatchingTextPipe implements PipeTransform {
  public transform(text: string, matching: string): string {
   
    if (text && matching && typeof text === 'string' && typeof matching === 'string') {
      const regex = new RegExp(matching, 'i');
      let splittedText = text.split(':');
      if(splittedText?.length == 2)
      {
        return splittedText[0] + ": " + splittedText[1].split(regex).join(`<b>${splittedText[1].match(regex)}</b>`);
      }
      return text.split(regex).join(`<b>${text.match(regex)}</b>`);
    }
    return text;
  }
}
